<template>
  <div class="contain-content grid gap-x-4 content-visibility-auto md:cols-12">
    <div class="mb-4 md:hidden">
      <div class="h-3 w-24 skeleton" />
      <div class="mt-4 h-4 skeleton md:w-64" />
      <div class="mt-2 h-4 w-64 skeleton" />
      <div class="mt-6 h-4 w-14 skeleton" />
      <div class="mt-6 h-3 w-70 skeleton" />
      <div class="mt-2 flex gap-2">
        <div class="h-3 w-14 skeleton" />
        <div class="h-3 w-18 skeleton" />
      </div>
    </div>
    <div class="f-col gap-4 md:col-start-1 md:col-end-8 lg:col-end-9">
      <div class="cols-2 gap-4 lg:grid !gap-2">
        <div
          v-for="i in 6"
          :key="i"
          class="skeleton"
          :class="{ '<lg:hidden': i > 1 }"
          :style="{ 'aspect-ratio': presets.src.width / presets.src.height }"
        />
      </div>
      <div class="flex center gap-2 lg:hidden">
        <div v-for="i in 3" :key="i" class="aspect-square w-2 skeleton" />
      </div>
      <div class="mt-4 f-col children:skeleton center gap-1 lg:mt-8 <md:hidden">
        <div class="h-4 w-full lg:w-2/3" />
        <div class="h-4 w-full lg:w-2/3" />
      </div>
      <div class="mt-1 flex gap-x-4 <md:hidden">
        <div v-for="i in 4" :key="i" class="aspect-square w-full skeleton" :class="{ '<lg:hidden': i > 3 }" />
      </div>
      <div class="mt-8 w-full skeleton <md:hidden" style="height: 15.5rem" />
    </div>
    <div class="lg:col-span-4 md:col-span-5">
      <div class="children:skeleton <md:hidden">
        <div class="h-4 w-35" />
        <div class="mt-3 h-4 w-full lg:h-6" />
        <div class="mt-2 h-4 w-full lg:h-6" />
        <div class="mt-6 h-4 w-38" />
        <div class="mt-5 h-4 w-full" />
        <div class="mt-1 h-4 w-38 md:mt-2" />
        <div class="mt-14 h-4 w-38 lg:mt-10" />
      </div>
      <div class="mt-6 h-4 w-38 skeleton md:hidden" />
      <div class="mt-7 f-col gap-2 md:mt-10">
        <div class="h-3 w-38 skeleton <md:mt-2 md:mb-0.5" />
        <div class="flex gap-4 wrap lg:gap-2">
          <div
            v-for="i in 8"
            :key="i"
            class="aspect-square w-6 skeleton rounded-full"
          />
        </div>
        <div class="mt-7 h-3 w-38 skeleton" />
        <div class="mt-1 flex gap-2 wrap">
          <div v-for="i in 12" :key="i" class="aspect-square skeleton" style="width: 2.5rem" />
        </div>
        <div class="mt-2 h-4 w-33 skeleton md:w-25" />
        <div class="mt-1 flex gap-2">
          <div v-for="i in 3" :key="i" class="h-10 w-16 skeleton" />
        </div>
        <div class="mt-3 h-3 w-33 skeleton md:w-25" />
        <div class="mt-2 h-3 w-24 skeleton" />
        <div class="mt-6 w-full skeleton" style="height: 1px" />
        <div class="mt-2 h-12 skeleton lg:h-14" />
        <div class="mt-2 flex children:skeleton gap-2">
          <div class="h-12 w-full lg:h-14" />
          <div class="aspect-square h-12 lg:h-14" />
        </div>
        <div class="mt-2 h-6 w-full skeleton" />
        <div class="mt-2 h-6 w-full skeleton" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { presets } = useAppConfig().pages.pdp.gallery
</script>
